import { IMAGES } from '../consts'

export const getProfilePicture = profilePicture => {
  if (profilePicture && profilePicture.includes(IMAGES.BASE64_PREFIX)) {
    // User uploaded image
    return { uri: profilePicture }
  }
  return null
}

export const getBase64 = file =>
  new Promise(function (resolve, reject) {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject('Error: ', error)
  })
